module.exports = __webpack_public_path__ + "img/career_support_logo_color.50fe6994.png";